import { config } from "../../../../../config";
import http from "../../../../../http";
import { GET_TITLE_BEGIN, GET_TITLE_SUCCESS } from "./type";
import { hasErrors } from "../../../error/actions";

export const getTitle = () => {
    return async dispatch => {
        try {
            dispatch(getBegin())
            const result = await http.get(config.api.COMMON.TITLE_REASON.GET_TITLES)
            dispatch(getSuccess(result))
        } catch (error) {
            dispatch(hasErrors(error))
        }
    }
}

const getBegin = () => {
    return dispatch => {
        dispatch({ type: GET_TITLE_BEGIN })
    }
}
const getSuccess = (items) => {
    return dispatch => {
        dispatch({ type: GET_TITLE_SUCCESS, payload: { items, loading: false } })
    }
}